import { LeftMenuFileItem } from '../../../com/leftMenufileItem/LeftMenuFileItem'

import downloadIcon from '../../../../assets/editors/download_xls_icon.svg'
import uploadIcon from '../../../../assets/editors/upload_xls_icon.svg'

import './FlyerEditorLeftMenu.scss'

interface IFlyerEditorLeftMenu {
    onSpotsFileSelected: (file: File) => void,
}

export const FlyerEditorLeftMenu: React.FC<IFlyerEditorLeftMenu> = (props) => {

    return (
        <div className="flyers_promo_items_editor_left_menu">
            <p>Promo Items</p>
            <div className="spots_files_items_container">

                {/* <LeftMenuFileItem 
                    imageSrc={downloadIcon} 
                    title="Download Sample file" 
                    isForDownloading={true} 
                /> */}

                <LeftMenuFileItem
                    imageSrc={uploadIcon}
                    title="Upload Promo Items file"
                    isForDownloading={false}
                    onFileSelected={props.onSpotsFileSelected}
                />

            </div>
            <hr />
        </div>
    )
}